import LegalLayout, { Section } from "../components/LegalLayout";

export default function RefundPage() {
  return (
    <LegalLayout
      title="Refund Policy"
      lastUpdated="February 2026"
      testid="refund-page"
      intro="We want you to feel great about your decision. Here's exactly when and how refunds work."
    >
      <Section heading="1. Our commitment">
        <p>
          Feel Greats is committed to high-quality, ethical wellness commerce. We honour all
          consumer-protection rights you have under UK law (including the Consumer Contracts
          Regulations 2013) and try to go a step further with a transparent, customer-friendly
          refund process.
        </p>
      </Section>

      <Section heading="2. 14-day cancellation right">
        <p>
          Under UK law, if you've purchased a digital service (such as a Feel Greats
          subscription) and you have not yet started using it, you have <strong>14 days</strong>{" "}
          from the date of purchase to cancel for a full refund.
        </p>
        <p>
          Once you actively use the service (e.g. you complete the assessment, view the report or
          consume any portion of a subscription period), the right to a refund for that period is
          waived. You can still cancel future renewals at any time.
        </p>
      </Section>

      <Section heading="3. Physical products (Unicity Feel Great System)">
        <p>
          Physical product orders are fulfilled by Unicity International. Refund and return
          policies for physical product shipments are governed by Unicity's own terms. For help
          with a physical product order — including damaged, missing or incorrect items — email
          us at{" "}
          <a className="text-emerald-700 font-semibold" href="mailto:support@feelgreats.co.uk">
            support@feelgreats.co.uk
          </a>{" "}
          and we will help you contact Unicity directly and follow up on your behalf where we
          can.
        </p>
      </Section>

      <Section heading="4. How to request a refund">
        <p>To request a refund, email{" "}
          <a className="text-emerald-700 font-semibold" href="mailto:support@feelgreats.co.uk">
            support@feelgreats.co.uk
          </a>{" "}
          with:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>The email address on your Feel Greats account</li>
          <li>The order or transaction reference (you'll find it in your confirmation email)</li>
          <li>A short reason for the request</li>
        </ul>
        <p>
          We respond to refund requests within 1 business day and process approved refunds
          within 5–10 business days back to your original payment method.
        </p>
      </Section>

      <Section heading="5. Subscription cancellations">
        <p>
          You can cancel an active subscription at any time. Cancellation stops future billing
          immediately. Already-paid periods are not refundable beyond the 14-day cancellation
          window described above, except where required by law or in cases of clear technical
          error.
        </p>
      </Section>

      <Section heading="6. Discounts, coupons &amp; referral rewards">
        <p>
          Refunds are calculated based on the actual amount paid (after any coupon, subscription
          discount or referral discount). If a refund is issued on a transaction that triggered
          a referral reward, we may reverse the corresponding bonus credit on the referrer's
          account.
        </p>
      </Section>

      <Section heading="7. Chargebacks">
        <p>
          If you have a problem, please contact us first — we'll usually resolve it the same
          day. Initiating a chargeback through your bank without first contacting{" "}
          <a className="text-emerald-700 font-semibold" href="mailto:support@feelgreats.co.uk">
            support@feelgreats.co.uk
          </a>{" "}
          may result in suspension of your account and additional fees passed on by Stripe.
        </p>
      </Section>

      <Section heading="8. Exceptions">
        <p>
          Refunds may be declined where there is clear evidence of fraud, abuse of promotional
          codes, or use of the Service in breach of our{" "}
          <a className="text-emerald-700 font-semibold" href="/terms">
            Terms &amp; Conditions
          </a>
          .
        </p>
      </Section>
    </LegalLayout>
  );
}
